import { render } from "./Footer.vue?vue&type=template&id=7f4500ec"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7f4500ec&lang=scss"

import exportComponent from "/home/sc1nboq9356/staging-meiser/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__